import { AxiosInstance } from 'axios';

import { emptyFunction } from '@/utils/emptyFunction.util.ts';

import { httpErrorHandler } from './httpErrorHandler.util';
import { retryWithFreshCsrf } from './retryWithFreshCsrf.util';

type Return = (error: unknown) => Promise<unknown> | undefined;

export const getErrorResponseInterceptor = (instance: AxiosInstance): Return => {
  return async error => {
    const retried = retryWithFreshCsrf(instance, error);

    if (retried) {
      return retried;
    }

    await httpErrorHandler(error, emptyFunction);
  };
};
